import React from 'react'

export const replaceNewLineEmojiAsString = (text: string) => {
  // When a string only is required
  return text.replace(/〽/g, '\n')
}

export const replaceNewLineEmojiAsElement = (text: string) => {
  const specialCharacter = '〽'

  // We return HTML element usually
  const lineBreaksCount = text.split(specialCharacter).length

  if (lineBreaksCount > 1) {
    const textArr = [...text].map((t, i) =>
      t === specialCharacter ? <br key={i} /> : t
    )

    return <span>{textArr}</span>
  } else {
    return <span>{text}</span>
  }
}

export const ignoreNewLineEmoji = (text: string) => {
  // When a string only is required
  return text.replace(/〽/g, ' ')
}
